/* gowin-cart-stability.js */
/* GOWin® Store — actualización quirúrgica del carrito, 2026-08-07 */
(() => {
  'use strict';

  if (window.GowinCartSurgicalUpdateInstalled) return;
  window.GowinCartSurgicalUpdateInstalled = true;

  const UPDATE_ATTR = 'data-gowin-quantity-update';
  const RECOMMENDATIONS_SELECTOR = '.gowin-drawer-shipping__recommendations';
  const VIEWPORT_SELECTOR = '.gowin-drawer-shipping__viewport';
  const DATA_SELECTORS = [
    '[data-gowin-cart-price-data]',
    '[data-gowin-cart-summary-data]',
  ];

  const installStyles = () => {
    if (document.getElementById('gowin-cart-surgical-update-style')) return;

    const style = document.createElement('style');
    style.id = 'gowin-cart-surgical-update-style';
    style.textContent = `
      cart-drawer[${UPDATE_ATTR}] cart-drawer-items {
        scroll-behavior: auto !important;
        overflow-anchor: none !important;
      }

      cart-drawer[${UPDATE_ATTR}] .cart-item__name:focus,
      cart-drawer[${UPDATE_ATTR}] .cart-item__name:focus-visible {
        outline: none !important;
        box-shadow: none !important;
      }
    `;
    document.head.appendChild(style);
  };

  const parseSection = (html, selector) => {
    if (typeof html !== 'string' || !html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  };

  const copyDataNode = (currentRoot, freshRoot, selector) => {
    const current = currentRoot?.querySelector(selector);
    const fresh = freshRoot?.querySelector(selector);

    if (current && fresh) {
      current.replaceWith(fresh.cloneNode(true));
      return;
    }

    if (!current && fresh) {
      currentRoot.prepend(fresh.cloneNode(true));
      return;
    }

    if (current && !fresh) current.remove();
  };

  const patchShipping = (currentCartItems, freshCartItems, preserveRecommendations) => {
    const currentShipping = currentCartItems?.querySelector('[data-gowin-drawer-shipping]');
    const freshShipping = freshCartItems?.querySelector('[data-gowin-drawer-shipping]');

    if (!currentShipping && freshShipping) {
      currentCartItems.prepend(freshShipping.cloneNode(true));
      return;
    }

    if (currentShipping && !freshShipping) {
      currentShipping.remove();
      return;
    }

    if (!currentShipping || !freshShipping) return;

    currentShipping.className = freshShipping.className;

    const currentStatus = currentShipping.querySelector('.gowin-drawer-shipping__status');
    const freshStatus = freshShipping.querySelector('.gowin-drawer-shipping__status');
    if (currentStatus && freshStatus) currentStatus.replaceWith(freshStatus.cloneNode(true));

    const currentRecommendations = currentShipping.querySelector(RECOMMENDATIONS_SELECTOR);
    const freshRecommendations = freshShipping.querySelector(RECOMMENDATIONS_SELECTOR);

    if (preserveRecommendations && currentRecommendations && freshRecommendations) {
      // Mantener el MISMO nodo evita que el carrusel desaparezca y reaparezca.
      return;
    }

    if (currentRecommendations && freshRecommendations) {
      currentRecommendations.replaceWith(freshRecommendations.cloneNode(true));
    } else if (currentRecommendations && !freshRecommendations) {
      currentRecommendations.remove();
    } else if (!currentRecommendations && freshRecommendations) {
      currentShipping.append(freshRecommendations.cloneNode(true));
    }
  };

  const patchCartRows = (currentCartItems, freshCartItems) => {
    const currentWrapper = currentCartItems?.querySelector('.drawer__cart-items-wrapper');
    const freshWrapper = freshCartItems?.querySelector('.drawer__cart-items-wrapper');

    if (currentWrapper && freshWrapper) {
      currentWrapper.replaceWith(freshWrapper.cloneNode(true));
    } else if (currentWrapper && !freshWrapper) {
      currentWrapper.remove();
    } else if (!currentWrapper && freshWrapper) {
      currentCartItems.append(freshWrapper.cloneNode(true));
    }
  };

  const patchFooter = (drawer, freshInner) => {
    const currentFooter = drawer.querySelector('.drawer__footer .cart-drawer__footer');
    const freshFooter = freshInner.querySelector('.drawer__footer .cart-drawer__footer');
    if (currentFooter && freshFooter) currentFooter.replaceWith(freshFooter.cloneNode(true));

    const currentCheckout = drawer.querySelector('#CartDrawer-Checkout');
    const freshCheckout = freshInner.querySelector('#CartDrawer-Checkout');
    if (currentCheckout && freshCheckout) currentCheckout.disabled = freshCheckout.disabled;
  };

  const patchIconBubble = (state) => {
    const html = state?.sections?.['cart-icon-bubble'];
    if (typeof html !== 'string') return;

    const current = document.getElementById('cart-icon-bubble');
    const freshSection = parseSection(html, '.shopify-section');
    const fresh = freshSection?.querySelector('#cart-icon-bubble');

    if (current && fresh) current.innerHTML = fresh.innerHTML;
  };

  const patchNonEmptyDrawer = (drawer, state, preserveRecommendations) => {
    const sectionHtml = state?.sections?.['cart-drawer'];
    const freshInner = parseSection(sectionHtml, '.drawer__inner');
    const currentItems = drawer.querySelector('cart-drawer-items');
    const currentCartItems = drawer.querySelector('#CartDrawer-CartItems');
    const freshCartItems = freshInner?.querySelector('#CartDrawer-CartItems');

    if (!freshInner || !currentItems || !currentCartItems || !freshCartItems) return false;

    const savedScrollTop = currentItems.scrollTop || 0;
    const currentRecommendations = currentCartItems.querySelector(RECOMMENDATIONS_SELECTOR);
    const currentViewport = currentRecommendations?.querySelector(VIEWPORT_SELECTOR);
    const savedRecommendationsLeft = currentViewport?.scrollLeft || 0;

    DATA_SELECTORS.forEach((selector) => copyDataNode(currentCartItems, freshCartItems, selector));
    patchShipping(currentCartItems, freshCartItems, preserveRecommendations);
    patchCartRows(currentCartItems, freshCartItems);
    patchFooter(drawer, freshInner);

    // El contenedor que hace scroll nunca fue reemplazado. Reafirmamos el valor
    // para neutralizar cualquier ajuste de scroll anchoring del navegador.
    currentItems.scrollTop = savedScrollTop;

    const survivingViewport = drawer.querySelector(`${RECOMMENDATIONS_SELECTOR} ${VIEWPORT_SELECTOR}`);
    if (preserveRecommendations && survivingViewport) {
      survivingViewport.scrollLeft = savedRecommendationsLeft;
    }

    return true;
  };

  const replaceWithEmptyDrawer = (drawer, state) => {
    const sectionHtml = state?.sections?.['cart-drawer'];
    const freshInner = parseSection(sectionHtml, '.drawer__inner');
    const currentInner = drawer.querySelector('.drawer__inner');
    if (!freshInner || !currentInner) return false;

    currentInner.innerHTML = freshInner.innerHTML;
    return true;
  };

  const focusWithoutScroll = (element) => {
    if (!(element instanceof HTMLElement)) return;
    try {
      element.focus({ preventScroll: true });
    } catch (_) {
      element.focus();
    }
  };

  const installUpdateQuantity = () => {
    const CartDrawerItems = customElements.get('cart-drawer-items');
    const prototype = CartDrawerItems?.prototype;
    if (!prototype || typeof prototype.updateQuantity !== 'function') return false;
    if (prototype.updateQuantity.GowinSurgicalWrapped) return true;

    const nativeUpdateQuantity = prototype.updateQuantity;

    const surgicalUpdateQuantity = function (line, quantity, event, name, variantId) {
      const drawer = this.closest('cart-drawer');
      if (!drawer) return nativeUpdateQuantity.call(this, line, quantity, event, name, variantId);

      const scrollContainer = this;
      const initialScrollTop = scrollContainer.scrollTop || 0;
      const oldRecommendations = drawer.querySelector(RECOMMENDATIONS_SELECTOR);
      const oldRecommendationsViewport = oldRecommendations?.querySelector(VIEWPORT_SELECTOR);
      const oldRecommendationsLeft = oldRecommendationsViewport?.scrollLeft || 0;
      const isRemoval = Number(quantity) === 0;

      drawer.setAttribute(UPDATE_ATTR, 'true');
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      const eventTarget =
        event?.currentTarget?.matches?.('cart-remove-button') ||
        event?.currentTarget?.closest?.('cart-remove-button')
          ? 'clear'
          : 'change';

      return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
        .then((response) => response.text())
        .then((text) => {
          const state = JSON.parse(text);

          if (state.errors) {
            const quantityElement =
              document.getElementById(`Quantity-${line}`) ||
              document.getElementById(`Drawer-quantity-${line}`);
            if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, state.errors);
            return state;
          }

          this.classList.toggle('is-empty', state.item_count === 0);
          drawer.classList.toggle('is-empty', state.item_count === 0);

          if (state.item_count === 0) {
            replaceWithEmptyDrawer(drawer, state);
          } else {
            const patched = patchNonEmptyDrawer(drawer, state, !isRemoval);
            if (!patched) {
              // Fallback de seguridad únicamente si el HTML esperado no existe.
              const freshInner = parseSection(state?.sections?.['cart-drawer'], '.drawer__inner');
              const currentInner = drawer.querySelector('.drawer__inner');
              if (freshInner && currentInner) currentInner.innerHTML = freshInner.innerHTML;
            }
          }

          patchIconBubble(state);

          if (state.item_count > 0) {
            // Reconstruir inmediatamente los controles personalizados sobre las filas nuevas.
            document.dispatchEvent(new CustomEvent('gowin:cart-patched', { detail: { line, quantity } }));

            // El mismo scroll container debe seguir vivo en una actualización normal.
            const currentScrollContainer = drawer.querySelector('cart-drawer-items');
            if (currentScrollContainer === scrollContainer) {
              currentScrollContainer.scrollTop = initialScrollTop;

              const survivingRecommendations = drawer.querySelector(RECOMMENDATIONS_SELECTOR);
              const survivingViewport = survivingRecommendations?.querySelector(VIEWPORT_SELECTOR);
              if (!isRemoval && survivingViewport && survivingRecommendations === oldRecommendations) {
                survivingViewport.scrollLeft = oldRecommendationsLeft;
              }
            }

            const newQuantityInput =
              document.getElementById(`Drawer-quantity-${line}`) ||
              drawer.querySelector(`.quantity__input[data-index="${line}"]`);
            const updatedValue = state.items?.[line - 1]?.quantity;
            let message = '';
            if (newQuantityInput && Number.isFinite(Number(updatedValue)) && Number(newQuantityInput.value) !== Number(updatedValue)) {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
            this.updateLiveRegions(line, message);

            // No usar el fallback nativo que enfoca .cart-item__name y desplaza el drawer.
            const neutralFocus = drawer.querySelector('.drawer__header .drawer__close') || drawer.querySelector('.drawer__inner');
            focusWithoutScroll(neutralFocus);

            requestAnimationFrame(() => {
              if (currentScrollContainer === scrollContainer && scrollContainer.isConnected) {
                scrollContainer.scrollTop = initialScrollTop;
              }
            });
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: state,
            variantId,
          });

          return state;
        })
        .catch((error) => {
          console.error('GOWin: error al actualizar la cantidad del carrito.', error);
          this.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          if (this.isConnected) this.disableLoading(line);
          window.setTimeout(() => drawer?.removeAttribute(UPDATE_ATTR), 180);
        });
    };

    surgicalUpdateQuantity.GowinSurgicalWrapped = true;
    surgicalUpdateQuantity.nativeUpdateQuantity = nativeUpdateQuantity;
    prototype.updateQuantity = surgicalUpdateQuantity;
    return true;
  };

  const install = () => {
    installStyles();
    installUpdateQuantity();
  };

  install();

  if (!customElements.get('cart-drawer-items')) {
    customElements.whenDefined('cart-drawer-items').then(installUpdateQuantity);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', install, { once: true })
    : install();

  document.addEventListener('shopify:section:load', install);
})();
;

/* gowin-cart-price-v1.js */
/* GOWin® Store — presentación de precios del carrito, 2026-08-07 */
(() => {
  if (window.GowinCartPriceV1) return;
  window.GowinCartPriceV1 = true;

  const DATA_SELECTOR = '[data-gowin-cart-price-data]';
  let scheduled = false;
  let observedDrawer = null;

  const visuallyHidden = (text) => {
    const span = document.createElement('span');
    span.className = 'visually-hidden';
    span.textContent = text;
    return span;
  };

  const signatureFor = (item) => [
    item.index,
    item.unitRegular,
    item.unitFinal,
    item.lineRegular,
    item.lineFinal,
    item.savingsPercent,
  ].join(':');

  const buildUnitPrice = (item) => {
    const root = document.createElement('div');
    root.className = 'gowin-cart-price';
    root.dataset.gowinPriceSignature = signatureFor(item);

    if (item.hasSavings) {
      const values = document.createElement('div');
      values.className = 'gowin-cart-price__values';

      values.append(visuallyHidden('Precio de oferta:'));
      const current = document.createElement('strong');
      current.className = 'gowin-cart-price__current';
      current.textContent = item.unitFinal;
      values.append(current);

      values.append(visuallyHidden('Precio regular:'));
      const regular = document.createElement('s');
      regular.className = 'gowin-cart-price__regular';
      regular.textContent = item.unitRegular;
      values.append(regular);

      const badge = document.createElement('span');
      badge.className = 'gowin-cart-price__badge';
      badge.textContent = `AHORRAS ${item.savingsPercent}%`;
      badge.setAttribute('aria-label', `Ahorras ${item.savingsPercent} por ciento`);

      root.append(values, badge);
      return root;
    }

    const current = document.createElement('span');
    current.className = 'gowin-cart-price__current gowin-cart-price__current--regular';
    current.textContent = item.unitFinal;
    root.append(current);
    return root;
  };

  const buildLinePrice = (item) => {
    const root = document.createElement('div');
    root.className = 'gowin-cart-line-price';
    root.dataset.gowinPriceSignature = signatureFor(item);

    if (item.hasSavings) {
      root.append(visuallyHidden('Total regular:'));
      const regular = document.createElement('s');
      regular.className = 'gowin-cart-line-price__regular';
      regular.textContent = item.lineRegular;
      root.append(regular);

      root.append(visuallyHidden('Total con descuento:'));
      const current = document.createElement('strong');
      current.className = 'gowin-cart-line-price__current';
      current.textContent = item.lineFinal;
      root.append(current);
      return root;
    }

    const current = document.createElement('strong');
    current.className = 'gowin-cart-line-price__current gowin-cart-line-price__current--regular';
    current.textContent = item.lineFinal;
    root.append(current);
    return root;
  };

  const replaceUnitPrice = (row, item) => {
    const title = row.querySelector('.cart-item__details .cart-item__name');
    const current = title?.nextElementSibling;
    if (!title || !current) return;

    const signature = signatureFor(item);
    if (current.matches('.gowin-cart-price') && current.dataset.gowinPriceSignature === signature) return;

    if (
      !current.matches(
        '.cart-item__discounted-prices, .product-option, .gowin-cart-price'
      )
    ) return;

    current.replaceWith(buildUnitPrice(item));
  };

  const replaceLinePrice = (row, item) => {
    const wrapper = row.querySelector('.cart-item__totals .cart-item__price-wrapper');
    if (!wrapper) return;

    const current = [...wrapper.children].find((element) =>
      element.matches('.cart-item__discounted-prices, .price.price--end, .gowin-cart-line-price')
    );
    if (!current) return;

    const signature = signatureFor(item);
    if (current.matches('.gowin-cart-line-price') && current.dataset.gowinPriceSignature === signature) return;

    current.replaceWith(buildLinePrice(item));
  };

  const readData = (drawer) => {
    const dataElement = drawer.querySelector(DATA_SELECTOR);
    if (!dataElement) return [];

    try {
      const parsed = JSON.parse(dataElement.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('GOWin: no se pudo leer la información de precios del carrito.', error);
      return [];
    }
  };

  const enhance = () => {
    scheduled = false;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const data = readData(drawer);
    if (!data.length) return;

    const rows = Array.from(drawer.querySelectorAll('.cart-items .cart-item'));

    data.forEach((item, position) => {
      const row = rows[position] || drawer.querySelector(`#CartDrawer-Item-${item.index}`);
      if (!row) return;
      replaceUnitPrice(row, item);
      replaceLinePrice(row, item);
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  const observer = new MutationObserver(schedule);

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (drawer !== observedDrawer) {
      observer.disconnect();
      observer.observe(drawer, { childList: true, subtree: true });
      observedDrawer = drawer;
    }

    schedule();
  };

  const enhanceAfterPatch = () => {
    // Este listener se registra antes que el de cantidad (v3), por el orden de carga.
    // Así el precio existe cuando v3 reconstruye el selector de cantidad inline.
    enhance();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();

  document.addEventListener('gowin:cart-patched', enhanceAfterPatch);
  document.addEventListener('cart:updated', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
})();
;

/* gowin-cart-feed-style-v2.js */
/* GOWin® Store — sincroniza el badge de ahorro del carrito con las tarjetas de colección */
(() => {
  if (window.GowinCartFeedStyleV2) return;
  window.GowinCartFeedStyleV2 = true;

  let observer;
  let observedDrawer;

  const normalizeSavingsBadges = (root = document) => {
    root.querySelectorAll('.gowin-cart-price__badge').forEach((badge) => {
      const match = (badge.textContent || '').match(/(\d+)\s*%/);
      if (!match) return;

      const percent = match[1];
      const desiredText = `AHORRO ${percent}%`;
      if (badge.textContent !== desiredText) badge.textContent = desiredText;
      badge.setAttribute('aria-label', `Ahorro ${percent} por ciento`);
    });
  };

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    normalizeSavingsBadges(drawer);

    if (drawer === observedDrawer) return;
    observer?.disconnect();
    observer = new MutationObserver(() => normalizeSavingsBadges(drawer));
    observer.observe(drawer, { childList: true, subtree: true, characterData: true });
    observedDrawer = drawer;
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();

  document.addEventListener('cart:updated', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
})();
;

/* gowin-cart-feed-style-v4.js */
/* GOWin® Store — carrito v4: cantidad inline estilo The Feed + cantidades manuales agrupadas */
(() => {
  if (window.GowinCartFeedStyleV4) return;
  window.GowinCartFeedStyleV4 = true;

  const DIRECT_QTY_MAX = 10;
  const CUSTOM_VALUE = '__gowin_custom_qty__';
  let observer;
  let observedDrawer;
  let scheduled = false;
  let wasOpen = false;

  const getCurrentQty = (input) => Math.max(1, parseInt(input?.value || '1', 10) || 1);

  const getExplicitMax = (input) => {
    const max = parseInt(input?.getAttribute('max') || '', 10);
    return Number.isFinite(max) && max > 0 ? max : null;
  };

  const updateRealQuantity = (input, nextQty) => {
    if (!input || !Number.isFinite(nextQty)) return;
    if (String(input.value) === String(nextQty)) return;
    input.value = String(nextQty);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const populateSelect = (select, input) => {
    const currentQty = getCurrentQty(input);
    const explicitMax = getExplicitMax(input);
    const directMax = Math.min(DIRECT_QTY_MAX, explicitMax || DIRECT_QTY_MAX);
    const allowCustom = explicitMax === null || explicitMax > DIRECT_QTY_MAX || currentQty > DIRECT_QTY_MAX;
    const signature = `${currentQty}:${explicitMax || 'none'}:${input.disabled ? 1 : 0}`;

    if (select.dataset.gowinQtySignature === signature) {
      const expected = String(currentQty);
      if (select.value !== expected) select.value = expected;
      select.disabled = !!input.disabled;
      return;
    }

    const fragment = document.createDocumentFragment();

    const remove = document.createElement('option');
    remove.value = '0';
    remove.textContent = '0 (eliminar)';
    fragment.appendChild(remove);

    for (let qty = 1; qty <= directMax; qty += 1) {
      const option = document.createElement('option');
      option.value = String(qty);
      option.textContent = String(qty);
      option.selected = qty === currentQty;
      fragment.appendChild(option);
    }

    if (allowCustom) {
      const custom = document.createElement('option');
      custom.value = CUSTOM_VALUE;
      custom.textContent = '11+ (ingresar cantidad)';
      fragment.appendChild(custom);
    }

    /* En iOS, un optgroup crea la separación visual tipo “Previous Inputs” de The Feed.
       La cantidad manual actual queda debajo de 11+, no mezclada con 1–10. */
    if (currentQty > DIRECT_QTY_MAX) {
      const previous = document.createElement('optgroup');
      previous.label = 'Cantidades anteriores';

      const current = document.createElement('option');
      current.value = String(currentQty);
      current.textContent = String(currentQty);
      current.selected = true;

      previous.appendChild(current);
      fragment.appendChild(previous);
    }

    select.replaceChildren(fragment);
    select.disabled = !!input.disabled;
    select.value = String(currentQty);
    select.dataset.gowinQtySignature = signature;
  };

  const closeCustomInput = (wrapper, select, customInput) => {
    if (customInput?.isConnected) customInput.remove();
    wrapper?.classList.remove('gowin-cart-qty-inline--custom');
    if (select) {
      select.hidden = false;
      select.removeAttribute('aria-hidden');
      select.tabIndex = 0;
    }
  };

  const openCustomInput = (wrapper, select, input, removeButton, shouldFocus = true) => {
    if (!wrapper || !select || !input || wrapper.querySelector('.gowin-cart-qty-inline__custom')) return;

    const currentQty = getCurrentQty(input);
    const explicitMax = getExplicitMax(input);
    const customInput = document.createElement('input');
    customInput.className = 'gowin-cart-qty-inline__select gowin-cart-qty-inline__custom';
    customInput.style.setProperty('background-image', 'none', 'important');
    customInput.style.setProperty('padding', '0 .8rem', 'important');
    customInput.style.setProperty('text-align', 'center', 'important');
    customInput.type = 'number';
    customInput.inputMode = 'numeric';
    customInput.pattern = '[0-9]*';
    customInput.min = '0';
    customInput.step = input.getAttribute('step') || '1';
    customInput.value = String(currentQty > DIRECT_QTY_MAX ? currentQty : DIRECT_QTY_MAX + 1);
    customInput.setAttribute('aria-label', 'Ingresar cantidad');
    customInput.setAttribute('enterkeyhint', 'done');
    if (explicitMax !== null) customInput.max = String(explicitMax);
    if (input.disabled) customInput.disabled = true;

    select.hidden = true;
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    wrapper.classList.add('gowin-cart-qty-inline--custom');
    wrapper.appendChild(customInput);

    let committed = false;

    const commit = () => {
      if (committed || !customInput.isConnected) return;
      committed = true;

      const nextQty = parseInt(customInput.value || '', 10);
      if (!Number.isFinite(nextQty)) {
        closeCustomInput(wrapper, select, customInput);
        populateSelect(select, input);
        return;
      }

      if (nextQty <= 0) {
        removeButton?.click();
        return;
      }

      closeCustomInput(wrapper, select, customInput);
      updateRealQuantity(input, nextQty);

      window.setTimeout(() => {
        if (select.isConnected && input.isConnected) {
          populateSelect(select, input);
        }
      }, 900);
    };

    customInput.addEventListener('change', commit);
    customInput.addEventListener('blur', commit);
    customInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        customInput.blur();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        committed = true;
        closeCustomInput(wrapper, select, customInput);
        populateSelect(select, input);
        select.focus();
      }
    });

    if (shouldFocus) {
      requestAnimationFrame(() => {
        customInput.focus({ preventScroll: true });
        customInput.select();
      });
    }
  };

  const makeSelect = (row, input, removeButton) => {
    const wrapper = document.createElement('span');
    wrapper.className = 'gowin-cart-qty-inline';

    const select = document.createElement('select');
    select.className = 'gowin-cart-qty-inline__select';
    select.setAttribute(
      'aria-label',
      `Cantidad de ${row.querySelector('.cart-item__name')?.textContent?.trim() || 'producto'}`
    );

    select.addEventListener('change', (event) => {
      event.stopPropagation();

      if (select.value === CUSTOM_VALUE) {
        openCustomInput(wrapper, select, input, removeButton);
        return;
      }

      const nextQty = parseInt(select.value || '1', 10);
      if (nextQty === 0) {
        removeButton?.click();
        return;
      }

      updateRealQuantity(input, nextQty);

      window.setTimeout(() => {
        if (select.isConnected && input.isConnected) populateSelect(select, input);
      }, 900);
    });

    wrapper.appendChild(select);
    return { wrapper, select };
  };

  // Protección temporal mientras el Liquid histórico aún usa item.index.
  // No interviene en scroll ni recomendaciones.
  const repairRowIndex = (row, index) => {
    if (!row || !Number.isInteger(index) || index < 1) return;

    row.id = `CartDrawer-Item-${index}`;

    const input = row.querySelector('.cart-item__quantity .quantity__input');
    if (input) {
      input.id = `Drawer-quantity-${index}`;
      input.dataset.index = String(index);
    }

    const removeWrapper = row.querySelector('cart-remove-button');
    if (removeWrapper) {
      removeWrapper.id = `CartDrawer-Remove-${index}`;
      removeWrapper.dataset.index = String(index);
    }

    const error = row.querySelector('.cart-item__error');
    if (error) error.id = `CartDrawer-LineItemError-${index}`;
  };

  const enhanceRow = (row) => {
    const price = row.querySelector('.gowin-cart-price');
    const quantityCell = row.querySelector('.cart-item__quantity');
    const input = quantityCell?.querySelector('.quantity__input');
    const removeButton = quantityCell?.querySelector('.cart-remove-button');
    if (!price || !quantityCell || !input) return;

    let topline = price.querySelector(':scope > .gowin-cart-price__topline');
    if (!topline) {
      topline = document.createElement('div');
      topline.className = 'gowin-cart-price__topline';
      price.insertBefore(topline, price.firstChild);

      const values = price.querySelector(':scope > .gowin-cart-price__values');
      const regularCurrent = price.querySelector(':scope > .gowin-cart-price__current');
      if (values) topline.appendChild(values);
      else if (regularCurrent) topline.appendChild(regularCurrent);
    }

    let qtyWrapper = topline.querySelector('.gowin-cart-qty-inline');
    let select = qtyWrapper?.querySelector('select.gowin-cart-qty-inline__select');

    if (!qtyWrapper || !select) {
      const built = makeSelect(row, input, removeButton);
      qtyWrapper = built.wrapper;
      select = built.select;
      topline.appendChild(qtyWrapper);
    }

    populateSelect(select, input);
    quantityCell.classList.add('gowin-cart-quantity-cell--v3');
  };

  const enhance = () => {
    scheduled = false;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('.cart-items .cart-item').forEach((row, position) => {
      repairRowIndex(row, position + 1);
      enhanceRow(row);
    });
  };

  const scheduleEnhance = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  const resetDrawerToTop = (drawer) => {
    const scrollArea = drawer.querySelector('cart-drawer-items');
    if (!scrollArea) return;
    requestAnimationFrame(() => {
      scrollArea.scrollTop = 0;
    });
  };

  const observeDrawer = (drawer) => {
    if (drawer === observedDrawer) return;

    observer?.disconnect();
    observer = new MutationObserver((mutations) => {
      scheduleEnhance();

      const drawerClassChanged = mutations.some(
        (mutation) =>
          mutation.target === drawer &&
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
      );

      if (drawerClassChanged) {
        const isOpen = drawer.classList.contains('active');
        if (isOpen && !wasOpen) resetDrawerToTop(drawer);
        wasOpen = isOpen;
      }
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    observedDrawer = drawer;
    wasOpen = drawer.classList.contains('active');
  };

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    observeDrawer(drawer);
    scheduleEnhance();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();

  document.addEventListener('gowin:cart-patched', enhance);
  document.addEventListener('cart:updated', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
})();
;

/* gowin-cart-qty-runtime-fix-v1.js */
/* GOWin® Store — quantity keyboard fix v1 */
(() => {
  if (window.GowinCartQtyRuntimeFixV1) return;
  window.GowinCartQtyRuntimeFixV1 = true;

  const CUSTOM_INPUT = '.gowin-cart-qty-inline__custom';
  const REAL_INPUT = '.cart-item__quantity .quantity__input';
  const suppressedInputs = new WeakSet();

  const notifyCartUpdated = (state, line, quantity, variantId) => {
    if (!state || state.errors) return;
    const detail = {
      cart: state,
      cartData: state,
      line,
      quantity,
      variantId,
      source: 'gowin-quantity-keyboard',
    };

    document.dispatchEvent(new CustomEvent('cart:updated', { detail, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail, bubbles: true }));
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    /* Suppress only the synthetic Dawn change emitted by the legacy custom-input handler. */
    if (target.matches(REAL_INPUT) && !event.isTrusted && suppressedInputs.has(target)) {
      event.stopImmediatePropagation();
      suppressedInputs.delete(target);
      return;
    }

    if (!target.matches(CUSTOM_INPUT)) return;

    const nextQty = parseInt(target.value || '', 10);
    if (!Number.isFinite(nextQty) || nextQty <= 0) return;

    const row = target.closest('.cart-item');
    const realInput = row?.querySelector(REAL_INPUT);
    const cartItems = row?.closest('cart-drawer-items');
    const line = parseInt(realInput?.dataset?.index || '', 10);
    const variantId = realInput?.dataset?.quantityVariantId;

    if (!realInput || !cartItems || typeof cartItems.updateQuantity !== 'function' || !Number.isInteger(line) || line < 1) {
      return;
    }

    /* Mark before the legacy handler runs, so its synthetic change can't create a second update. */
    suppressedInputs.add(realInput);

    window.setTimeout(() => {
      if (!realInput.isConnected || !cartItems.isConnected) return;

      realInput.value = String(nextQty);
      const syntheticEvent = new Event('change', { bubbles: false, cancelable: true });
      const result = cartItems.updateQuantity(line, nextQty, syntheticEvent, null, variantId);

      if (result && typeof result.then === 'function') {
        result
          .then((state) => notifyCartUpdated(state, line, nextQty, variantId))
          .catch(() => {});
      }
    }, 0);
  }, true);
})();
;

/* gowin-cart-feed-style-v5.js */
/* GOWin® Store — carrito v5: resumen subtotal / descuentos / envío / total + jerarquía de recompensas */
(() => {
  if (window.GowinCartFeedStyleV5) return;
  window.GowinCartFeedStyleV5 = true;

  const DATA_SELECTOR = '[data-gowin-cart-summary-data]';
  let observer;
  let observedDrawer;
  let scheduled = false;

  const readData = (drawer) => {
    const node = drawer.querySelector(DATA_SELECTOR);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('GOWin: no se pudo leer el resumen del carrito.', error);
      return null;
    }
  };

  const makeRow = (label, value, modifier = '') => {
    const row = document.createElement('div');
    row.className = `gowin-cart-summary__row${modifier ? ` gowin-cart-summary__row--${modifier}` : ''}`;

    const labelNode = document.createElement('span');
    labelNode.className = 'gowin-cart-summary__label';
    labelNode.textContent = label;

    const valueNode = document.createElement('strong');
    valueNode.className = 'gowin-cart-summary__value';
    valueNode.textContent = value;

    row.append(labelNode, valueNode);
    return row;
  };

  const normalizeText = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .trim();

  const moneyToken = (value) => {
    const match = String(value || '').match(/₡\s*[\d.,]+/);
    return match ? match[0].replace(/\s+/g, '') : '';
  };

  const dedupeShippingProgressCopy = (drawer) => {
    const status = drawer.querySelector('[data-gowin-drawer-shipping] .gowin-drawer-shipping__status');
    const title = status?.querySelector('.gowin-drawer-shipping__title');
    const meta = status?.querySelector('.gowin-drawer-shipping__progress-meta');
    const helper = meta?.querySelector(':scope > span');
    const percent = meta?.querySelector(':scope > strong');
    if (!title || !meta || !helper) return false;

    const titleText = normalizeText(title.textContent);
    const helperText = normalizeText(helper.textContent);
    const titleMoney = moneyToken(title.textContent);
    const helperMoney = moneyToken(helper.textContent);
    const duplicate = Boolean(
      titleText.includes('te faltan') &&
      helperText.startsWith('faltan') &&
      titleMoney &&
      helperMoney &&
      titleMoney === helperMoney
    );

    helper.hidden = duplicate;
    if (duplicate) helper.setAttribute('aria-hidden', 'true');
    else helper.removeAttribute('aria-hidden');

    if (percent) percent.style.marginLeft = duplicate ? 'auto' : '';
    return duplicate;
  };

  const hasRewardsCopy = (element) => {
    if (!(element instanceof Element)) return false;
    const text = normalizeText(element.textContent);
    return (
      text.includes('al completar tu pedido') &&
      text.includes('recompensas') &&
      text.includes('gowin')
    );
  };

  const parentBelongsOnlyToRewards = (element) => {
    if (!(element instanceof Element) || !hasRewardsCopy(element)) return false;
    const text = normalizeText(element.textContent);
    return !(
      text.includes('subtotal') ||
      text.includes('total estimado') ||
      text.includes('pagar pedido') ||
      element.querySelector('.cart-drawer__footer, .cart__ctas')
    );
  };

  const findRewardsBlock = (drawer) => {
    const candidates = Array.from(
      drawer.querySelectorAll('p, span, div, section, aside')
    ).filter(hasRewardsCopy);

    if (!candidates.length) return null;

    candidates.sort((a, b) => {
      const aText = normalizeText(a.textContent).length;
      const bText = normalizeText(b.textContent).length;
      return aText - bText || a.children.length - b.children.length;
    });

    let block = candidates[0];
    let current = block;
    let depth = 0;

    while (current.parentElement && current.parentElement !== drawer && depth < 7) {
      const parent = current.parentElement;
      if (!drawer.contains(parent) || !parentBelongsOnlyToRewards(parent)) break;

      const style = window.getComputedStyle(parent);
      const hasVisibleBox =
        style.backgroundColor !== 'rgba(0, 0, 0, 0)' &&
        style.backgroundColor !== 'transparent';
      const hasRadius = parseFloat(style.borderTopLeftRadius || '0') >= 4;
      const isSingleChildWrapper = parent.children.length === 1;
      const semanticContainer = ['SECTION', 'ASIDE'].includes(parent.tagName);

      if (!(hasVisibleBox || hasRadius || isSingleChildWrapper || semanticContainer)) break;

      block = parent;
      current = parent;
      depth += 1;
    }

    return block;
  };

  const arrangeRewardsHierarchy = (drawer) => {
    const footer = drawer.querySelector('.drawer__footer');
    const totalsBox = footer?.querySelector(':scope > .cart-drawer__footer');
    if (!footer || !totalsBox) return false;

    const creditPanel = footer.querySelector(':scope > [data-gowin-store-credit-panel]');
    const rewardsBlock = findRewardsBlock(drawer);

    if (rewardsBlock && rewardsBlock !== totalsBox && !rewardsBlock.contains(totalsBox)) {
      rewardsBlock.setAttribute('data-gowin-rewards-before-totals', 'true');

      if (creditPanel && creditPanel !== rewardsBlock) {
        if (rewardsBlock.nextElementSibling !== creditPanel || rewardsBlock.parentElement !== footer) {
          footer.insertBefore(rewardsBlock, creditPanel);
        }

        if (creditPanel.nextElementSibling !== totalsBox) {
          footer.insertBefore(creditPanel, totalsBox);
        }

        return (
          rewardsBlock.parentElement === footer &&
          rewardsBlock.nextElementSibling === creditPanel &&
          creditPanel.nextElementSibling === totalsBox
        );
      }

      if (rewardsBlock.nextElementSibling !== totalsBox || rewardsBlock.parentElement !== footer) {
        footer.insertBefore(rewardsBlock, totalsBox);
      }

      return rewardsBlock.parentElement === footer && rewardsBlock.nextElementSibling === totalsBox;
    }

    if (creditPanel && creditPanel.nextElementSibling !== totalsBox) {
      footer.insertBefore(creditPanel, totalsBox);
    }

    return Boolean(creditPanel && creditPanel.nextElementSibling === totalsBox);
  };

  const enhance = () => {
    scheduled = false;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    dedupeShippingProgressCopy(drawer);
    arrangeRewardsHierarchy(drawer);

    const data = readData(drawer);
    const footer = drawer.querySelector('.drawer__footer .cart-drawer__footer');
    if (!data || !footer) return;

    const signature = [data.subtotal, data.discount, data.discountCents, data.shippingQualified, data.shipping, data.total].join('|');
    let summary = footer.querySelector('.gowin-cart-summary');

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'gowin-cart-summary';
      summary.setAttribute('role', 'status');
      summary.setAttribute('aria-live', 'polite');
      const totals = footer.querySelector('.totals');
      footer.insertBefore(summary, totals || footer.firstChild);
    }

    if (summary.dataset.gowinSummarySignature !== signature) {
      const discountText = Number(data.discountCents || 0) > 0 ? `−${data.discount}` : data.discount;
      const fragment = document.createDocumentFragment();
      fragment.append(
        makeRow('Subtotal', data.subtotal),
        makeRow('Descuentos', discountText, 'discount'),
        makeRow('Envío', data.shipping, data.shippingQualified ? 'shipping-free' : 'shipping'),
        makeRow('Total estimado', data.total, 'total')
      );
      summary.replaceChildren(fragment);
      summary.dataset.gowinSummarySignature = signature;
    }

    footer.classList.add('gowin-cart-summary-ready');
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (drawer !== observedDrawer) {
      observer?.disconnect();
      observer = new MutationObserver(schedule);
      observer.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true
      });
      observedDrawer = drawer;
    }
    schedule();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();

  document.addEventListener('gowin:cart-patched', enhance);
  document.addEventListener('cart:updated', bind);
  document.addEventListener('cart:refresh', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
})();
;

/* gowin-cart-hardening-v1.js */
/* GOWin® Store — hardening del carrito v1: concurrencia, reglas, scroll y accesibilidad */
(() => {
  'use strict';
  if (window.GowinCartHardeningV1) return;
  window.GowinCartHardeningV1 = true;

  const CUSTOM_INPUT = '.gowin-cart-qty-inline__custom';
  const REAL_INPUT = '.cart-item__quantity .quantity__input';
  const SUGGESTION_SOURCE = 'gowin-drawer-suggestion-v3';
  let trackedScroll = { inner: 0, items: 0, cartItems: 0, recommendations: 0 };
  let observer;

  const int = (value, fallback = null) => {
    const parsed = parseInt(value ?? '', 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const rulesFor = (input) => ({
    min: Math.max(1, int(input?.dataset?.min, 1)),
    max: int(input?.getAttribute('max')),
    step: Math.max(1, int(input?.getAttribute('step'), 1)),
  });

  const validQuantity = (input, quantity) => {
    const qty = int(quantity);
    if (!Number.isInteger(qty) || qty <= 0) return false;
    const { min, max, step } = rulesFor(input);
    return qty >= min && (max === null || qty <= max) && (qty - min) % step === 0;
  };

  const validationMessage = (input, quantity) => {
    const qty = int(quantity);
    const { min, max, step } = rulesFor(input);
    const strings = window.quickOrderListStrings || {};
    if (!Number.isInteger(qty) || qty < min) return strings.min_error?.replace('[min]', min) || `La cantidad mínima es ${min}.`;
    if (max !== null && qty > max) return strings.max_error?.replace('[max]', max) || `La cantidad máxima es ${max}.`;
    if ((qty - min) % step !== 0) return strings.step_error?.replace('[step]', step) || `La cantidad debe aumentar en incrementos de ${step} desde ${min}.`;
    return '';
  };

  const nextValidAtOrAbove = (input, floor) => {
    const { min, step } = rulesFor(input);
    if (floor <= min) return min;
    return min + Math.ceil((floor - min) / step) * step;
  };

  const rowFor = (input) => input?.closest?.('.cart-item');

  const getErrorParts = (row) => {
    if (!row) return {};
    const details = row.querySelector('.cart-item__details');
    const error = row.querySelector('.cart-item__error');
    const text = error?.querySelector('.cart-item__error-text');
    return { details, error, text };
  };

  const prepareError = (row) => {
    const { details, error, text } = getErrorParts(row);
    if (!details || !error || !text) return;
    if (error.parentElement !== details) details.appendChild(error);
    error.classList.add('gowin-cart-item-error-visible');

    const active = error.dataset.gowinErrorActive === 'true' && Boolean((text.textContent || '').trim());
    if (!active) {
      text.textContent = '';
      error.dataset.gowinErrorActive = 'false';
    }
    error.classList.toggle('is-visible', active);
    error.setAttribute('aria-hidden', active ? 'false' : 'true');
  };

  const setError = (row, message = '') => {
    const { details, error, text } = getErrorParts(row);
    if (!details || !error || !text) return;
    if (error.parentElement !== details) details.appendChild(error);
    error.classList.add('gowin-cart-item-error-visible');

    const value = String(message || '').trim();
    const active = Boolean(value);
    text.textContent = value;
    error.dataset.gowinErrorActive = active ? 'true' : 'false';
    error.classList.toggle('is-visible', active);
    error.setAttribute('aria-hidden', active ? 'false' : 'true');
  };

  const stateErrorMessage = (errors) => {
    if (!errors) return '';
    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors)) {
      return errors.map((item) => stateErrorMessage(item)).filter(Boolean).join(' ');
    }
    if (typeof errors === 'object') {
      return errors.description || errors.message || errors.error || '';
    }
    return String(errors);
  };

  const recoverableAvailabilityQuantity = (errors, requestedQuantity) => {
    const requested = int(requestedQuantity);
    if (!Number.isInteger(requested) || requested <= 1) return null;

    const message = stateErrorMessage(errors).replace(/\s+/g, ' ').trim();
    if (!message) return null;

    const patterns = [
      /\bsolo\s+se\s+(?:añadieron|agregaron)\s+(\d+)\s+(?:artículos|articulos|productos|unidades)\b/i,
      /\bsolo\s+(?:puedes|puede)\s+(?:añadir|agregar|comprar|tener)\s+(\d+)\b/i,
      /\bonly\s+(\d+)\s+(?:items?|products?|units?)\s+(?:were\s+)?added\b/i,
      /\b(?:you\s+can\s+)?only\s+(?:add|have|buy)\s+(\d+)\b/i,
      /\b(\d+)\s+(?:items?|products?|units?|artículos|articulos|productos|unidades)\s+(?:are\s+)?(?:available|disponibles?)\b/i,
    ];

    for (const pattern of patterns) {
      const match = message.match(pattern);
      const candidate = int(match?.[1]);
      if (Number.isInteger(candidate) && candidate > 0 && candidate < requested) return candidate;
    }

    return null;
  };

  const sanitizeRow = (row) => {
    const input = row.querySelector(REAL_INPUT);
    const select = row.querySelector('select.gowin-cart-qty-inline__select');
    if (!input) return;

    prepareError(row);

    if (select) {
      [...select.querySelectorAll('option')].forEach((option) => {
        const qty = int(option.value);
        if (qty !== null && qty > 0 && !validQuantity(input, qty) && Number(option.value) !== Number(input.value)) option.remove();
      });
    }

    const custom = row.querySelector(CUSTOM_INPUT);
    if (custom) {
      const { min, max, step } = rulesFor(input);
      custom.min = String(min);
      custom.step = String(step);
      if (max !== null) custom.max = String(max);
      else custom.removeAttribute('max');
      const current = int(custom.value);
      if (!validQuantity(input, current)) {
        const next = nextValidAtOrAbove(input, 11);
        if (max === null || next <= max) custom.value = String(next);
      }
    }
  };

  const sanitize = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.cart-items .cart-item').forEach(sanitizeRow);
  };

  const captureScroll = (drawer = document.querySelector('cart-drawer')) => {
    if (!drawer) return { ...trackedScroll };
    const inner = drawer.querySelector('.drawer__inner');
    const items = drawer.querySelector('cart-drawer-items');
    const cartItems = drawer.querySelector('#CartDrawer-CartItems');
    const recommendations = drawer.querySelector('.gowin-drawer-shipping__viewport');
    return {
      inner: inner?.scrollTop || 0,
      items: items?.scrollTop || 0,
      cartItems: cartItems?.scrollTop || 0,
      recommendations: recommendations?.scrollLeft || 0,
    };
  };

  const restoreScroll = (drawer, state) => {
    if (!drawer || !state) return;
    const inner = drawer.querySelector('.drawer__inner');
    const items = drawer.querySelector('cart-drawer-items');
    const cartItems = drawer.querySelector('#CartDrawer-CartItems');
    const recommendations = drawer.querySelector('.gowin-drawer-shipping__viewport');
    if (inner) inner.scrollTop = state.inner;
    if (items) items.scrollTop = state.items;
    if (cartItems) cartItems.scrollTop = state.cartItems;
    if (recommendations) recommendations.scrollLeft = state.recommendations;
  };

  const refreshEmptyFocus = (drawer) => {
    if (!drawer?.classList.contains('is-empty') || typeof window.trapFocus !== 'function') return;
    requestAnimationFrame(() => {
      const container = drawer.querySelector('.drawer__inner');
      const target = drawer.querySelector('.drawer__header .drawer__close') || drawer.querySelector('.cart-drawer__empty-content a[href]') || container;
      if (container && target) window.trapFocus(container, target);
    });
  };

  const installQuantityGuard = () => {
    const CartDrawerItems = customElements.get('cart-drawer-items');
    const prototype = CartDrawerItems?.prototype;
    if (!prototype || typeof prototype.updateQuantity !== 'function') return false;
    if (prototype.updateQuantity.GowinHardeningV1) return true;

    const wrapped = prototype.updateQuantity;
    const hardened = function (line, quantity, event, name, variantId) {
      const drawer = this.closest('cart-drawer');
      if (!drawer) return wrapped.call(this, line, quantity, event, name, variantId);

      const input = drawer.querySelector(`${REAL_INPUT}[data-index="${line}"]`) || document.getElementById(`Drawer-quantity-${line}`);
      const qty = int(quantity, 0);
      if (qty > 0 && input && !validQuantity(input, qty)) {
        const message = validationMessage(input, qty);
        input.value = input.getAttribute('value') || input.value;
        setError(rowFor(input), message);
        document.dispatchEvent(new CustomEvent('gowin:cart-patched', { detail: { line, quantity: qty, error: true, clientValidation: true } }));
        return Promise.resolve({ errors: message });
      }

      if (input) setError(rowFor(input), '');

      const scrollState = captureScroll(drawer);

      const finalizeState = (state, preferredMessage = '') => {
        restoreScroll(drawer, scrollState);
        requestAnimationFrame(() => restoreScroll(drawer, scrollState));

        const currentRow = drawer.querySelector(`#CartDrawer-Item-${line}`);
        const serverMessage = stateErrorMessage(state?.errors);
        const actualQuantity = int(state?.items?.[line - 1]?.quantity);
        const adjustedMessage = !serverMessage && qty > 0 && actualQuantity !== null && actualQuantity !== qty
          ? (window.cartStrings?.quantityError?.replace('[quantity]', actualQuantity) || `La cantidad disponible se ajustó a ${actualQuantity}.`)
          : '';
        const message = preferredMessage || serverMessage || adjustedMessage;
        setError(currentRow, message);
        if (message && typeof this.updateLiveRegions === 'function') this.updateLiveRegions(line, message);

        refreshEmptyFocus(drawer);
        sanitize();
        return state;
      };

      const run = () => Promise.resolve(wrapped.call(this, line, quantity, event, name, variantId)).then((state) => {
        const initialMessage = stateErrorMessage(state?.errors);
        const recoveryQuantity = recoverableAvailabilityQuantity(state?.errors, qty);

        if (!state?.errors || recoveryQuantity === null || !input || !validQuantity(input, recoveryQuantity)) {
          return finalizeState(state);
        }

        return Promise.resolve(wrapped.call(this, line, recoveryQuantity, event, name, variantId)).then((recoveredState) => {
          const recoveryError = stateErrorMessage(recoveredState?.errors);
          if (recoveryError) return finalizeState(recoveredState);

          const actualQuantity = int(recoveredState?.items?.[line - 1]?.quantity, recoveryQuantity);
          const message = actualQuantity !== recoveryQuantity
            ? (window.cartStrings?.quantityError?.replace('[quantity]', actualQuantity) || `La cantidad disponible se ajustó a ${actualQuantity}.`)
            : initialMessage;

          return finalizeState(recoveredState, message);
        });
      });

      const previous = this._gowinHardeningQueue || Promise.resolve();
      const task = previous.catch(() => undefined).then(run);
      this._gowinHardeningQueue = task;
      return task;
    };

    hardened.GowinHardeningV1 = true;
    hardened.wrappedUpdateQuantity = wrapped;
    prototype.updateQuantity = hardened;
    return true;
  };

  const bindCustomValidation = () => {
    document.addEventListener('change', (event) => {
      const custom = event.target;
      if (!(custom instanceof Element) || !custom.matches(CUSTOM_INPUT)) return;
      const row = custom.closest('.cart-item');
      const input = row?.querySelector(REAL_INPUT);
      if (!input) return;
      const qty = int(custom.value);
      const message = validationMessage(input, qty);
      custom.setCustomValidity(message);
      if (!message) {
        setError(row, '');
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      setError(row, message);
      custom.reportValidity();
    }, true);

    document.addEventListener('input', (event) => {
      const custom = event.target;
      if (!(custom instanceof Element) || !custom.matches(CUSTOM_INPUT)) return;
      custom.setCustomValidity('');
      setError(custom.closest('.cart-item'), '');
    }, true);
  };

  const bindScrollTracking = () => {
    trackedScroll = captureScroll();
    document.addEventListener('scroll', (event) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !(event.target instanceof Element) || !drawer.contains(event.target)) return;
      trackedScroll = captureScroll(drawer);
    }, true);

    document.addEventListener('cart:updated', (event) => {
      if (event.detail?.source !== SUGGESTION_SOURCE) return;
      const drawer = document.querySelector('cart-drawer');
      const saved = { ...trackedScroll };
      requestAnimationFrame(() => requestAnimationFrame(() => requestAnimationFrame(() => {
        restoreScroll(drawer, saved);
        trackedScroll = { ...saved };
        sanitize();
      })));
    });
  };

  const bindObserver = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    observer?.disconnect();
    observer = new MutationObserver(() => requestAnimationFrame(sanitize));
    observer.observe(drawer, { childList: true, subtree: true, characterData: true });
    sanitize();
  };

  const install = () => {
    installQuantityGuard();
    bindObserver();
  };

  bindCustomValidation();
  bindScrollTracking();
  install();
  if (!customElements.get('cart-drawer-items')) customElements.whenDefined('cart-drawer-items').then(installQuantityGuard);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', install, { once: true }) : install();
  document.addEventListener('shopify:section:load', install);
  document.addEventListener('gowin:cart-patched', sanitize);
  window.addEventListener('pageshow', sanitize);
})();
;

/* gowin-cart-suggestion-layout-fix-v1.js */
/* GOWin® Store — actualización quirúrgica de sugeridos, 2026-08-08.
   Mantiene estable el drawer y corrige restos del shell de carrito vacío. */
(()=>{
  if(window.GowinCartSuggestionSurgicalV3)return;
  window.GowinCartSuggestionSurgicalV3=true;

  const SELECTOR='[data-gowin-drawer-add]';
  let adding=false;

  const closeDrawer=(drawer)=>{
    if(typeof drawer?.close==='function'){
      drawer.close();
      return;
    }
    drawer?.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  };

  const getStaleEmptyShell=(root)=>{
    if(!root)return null;
    const contents=root.id==='CartDrawer'
      ?root
      :root.querySelector?.('#CartDrawer');
    return contents?.querySelector('.drawer__inner > .drawer__inner-empty')||null;
  };

  const sanitizeNonEmptyStructure=(drawer)=>{
    if(!drawer||drawer.classList.contains('is-empty'))return false;
    const stale=getStaleEmptyShell(drawer);
    if(!stale)return false;
    stale.remove();
    return true;
  };

  const resetDrawerScroll=(drawer)=>{
    if(!drawer)return;
    const shell=drawer.querySelector('#CartDrawer');
    const inner=drawer.querySelector('.drawer__inner');
    const items=drawer.querySelector('cart-drawer-items');
    const contents=drawer.querySelector('#CartDrawer-CartItems');
    const suggestions=drawer.querySelector('[data-gowin-drawer-suggestions]');
    [shell,inner,items,contents].forEach(node=>{ if(node)node.scrollTop=0; });
    if(items)items.scrollLeft=0;
    if(contents)contents.scrollLeft=0;
    if(suggestions)suggestions.scrollLeft=0;
  };

  const updateCartBubble=(markup)=>{
    if(!markup)return;
    const currentIcon=document.querySelector('#cart-icon-bubble');
    if(!currentIcon)return;
    const iconDoc=new DOMParser().parseFromString(markup,'text/html');
    const iconSection=iconDoc.querySelector('#shopify-section-cart-icon-bubble,.shopify-section');
    const nextIconHTML=iconSection?.innerHTML?.trim()||iconDoc.body?.innerHTML?.trim();
    if(nextIconHTML)currentIcon.innerHTML=nextIconHTML;
  };

  const bindOverlay=(drawer)=>{
    const overlay=drawer?.querySelector('#CartDrawer-Overlay');
    if(!overlay||overlay.dataset.gowinSurgicalCloseBound==='true')return;
    overlay.dataset.gowinSurgicalCloseBound='true';
    overlay.addEventListener('click',()=>closeDrawer(drawer));
  };

  const patchNonEmptyDrawer=(currentContents,nextContents)=>{
    const currentItemsHost=currentContents.querySelector('cart-drawer-items');
    const nextItemsHost=nextContents.querySelector('cart-drawer-items');
    const currentItems=currentContents.querySelector('#CartDrawer-CartItems');
    const nextItems=nextContents.querySelector('#CartDrawer-CartItems');
    const currentErrors=currentContents.querySelector('#CartDrawer-CartErrors');
    const nextErrors=nextContents.querySelector('#CartDrawer-CartErrors');
    const currentFooter=currentContents.querySelector('.drawer__footer');
    const nextFooter=nextContents.querySelector('.drawer__footer');
    if(!currentItemsHost||!nextItemsHost||!currentItems||!nextItems||!currentFooter||!nextFooter)return false;
    currentItems.innerHTML=nextItems.innerHTML;
    currentFooter.innerHTML=nextFooter.innerHTML;
    currentItemsHost.className=nextItemsHost.className;
    if(currentErrors&&nextErrors)currentErrors.innerHTML=nextErrors.innerHTML;
    return true;
  };

  const refreshDrawer=async(drawer)=>{
    const root=window.Shopify?.routes?.root||'/';
    const separator=root.includes('?')?'&':'?';
    const response=await fetch(`${root}${separator}sections=cart-drawer,cart-icon-bubble`,{headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},cache:'no-store'});
    if(!response.ok)throw new Error('No se pudo actualizar el carrito');
    const sections=await response.json();
    const drawerMarkup=sections['cart-drawer'];
    if(!drawerMarkup)throw new Error('No se recibió el contenido del carrito');
    const parsed=new DOMParser().parseFromString(drawerMarkup,'text/html');
    const nextDrawer=parsed.querySelector('cart-drawer');
    const nextContents=parsed.querySelector('#CartDrawer');
    const currentContents=drawer.querySelector('#CartDrawer');
    if(!nextContents||!currentContents)throw new Error('El carrito no pudo renderizarse');
    const staleEmptyShell=currentContents.querySelector('.drawer__inner > .drawer__inner-empty');
    const currentIsEmpty=drawer.classList.contains('is-empty')||Boolean(staleEmptyShell);
    const nextIsEmpty=nextDrawer?.classList.contains('is-empty')||false;
    let patched=false;
    if(!currentIsEmpty&&!nextIsEmpty)patched=patchNonEmptyDrawer(currentContents,nextContents);
    if(!patched)currentContents.innerHTML=nextContents.innerHTML;
    drawer.classList.toggle('is-empty',nextIsEmpty);
    if(!nextIsEmpty)getStaleEmptyShell(currentContents)?.remove();
    drawer.classList.add('animate','active');
    document.body.classList.add('overflow-hidden');
    bindOverlay(drawer);
    resetDrawerScroll(drawer);
    requestAnimationFrame(()=>{resetDrawerScroll(drawer);requestAnimationFrame(()=>resetDrawerScroll(drawer));});
    updateCartBubble(sections['cart-icon-bubble']);
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'gowin-drawer-add'}}));
  };

  const handleAdd=async(event)=>{
    const button=event.target.closest?.(SELECTOR);
    if(!button||adding)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const drawer=button.closest('cart-drawer')||document.querySelector('cart-drawer');
    if(!drawer)return;
    const variantId=button.dataset.gowinDrawerAdd||button.dataset.variantId;
    if(!variantId)return;
    adding=true;
    const label=button.querySelector('span');
    const original=label?.textContent||button.textContent||'Agregar';
    button.setAttribute('aria-busy','true');
    button.disabled=true;
    if(label)label.textContent='Agregando…';
    try{
      const payload=new FormData();
      payload.append('id',variantId);
      payload.append('quantity','1');
      const response=await fetch(window.routes?.cart_add_url||'/cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:payload});
      const state=await response.json();
      if(!response.ok||state.status)throw new Error(state.description||'No se pudo agregar el producto');
      await refreshDrawer(drawer);
    }catch(error){
      if(label)label.textContent='Intenta otra vez';
      button.removeAttribute('aria-busy');
      button.disabled=false;
      setTimeout(()=>{if(button.isConnected&&label)label.textContent=original;},1800);
    }finally{adding=false;}
  };

  const init=()=>{
    const drawer=document.querySelector('cart-drawer');
    sanitizeNonEmptyStructure(drawer);
    bindOverlay(drawer);
    resetDrawerScroll(drawer);
  };

  document.addEventListener('click',handleAdd,true);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('cart:updated',()=>requestAnimationFrame(()=>{const drawer=document.querySelector('cart-drawer');sanitizeNonEmptyStructure(drawer);bindOverlay(drawer);}));
})();
;

/* gowin-cart-availability-fast-v1.js */
/* GOWin® Store — disponibilidad inmediata v1: mostrar el límite desde la primera respuesta de Shopify */
(() => {
  'use strict';
  if (window.GowinCartAvailabilityFastV1) return;
  window.GowinCartAvailabilityFastV1 = true;

  const ROW = '.cart-item';
  const REAL_INPUT = '.cart-item__quantity .quantity__input';
  const ERROR = '.cart-item__error';
  const ERROR_TEXT = '.cart-item__error-text';
  const QUANTITY_CONTROL = [
    'select.gowin-cart-qty-inline__select',
    '.gowin-cart-qty-inline__custom',
    REAL_INPUT,
  ].join(',');

  const stickyMessages = new Map();
  let observer;

  const lineKey = (row) => {
    if (!row) return '';
    const input = row.querySelector(REAL_INPUT);
    if (input?.dataset?.index) return String(input.dataset.index);
    const match = String(row.id || '').match(/CartDrawer-Item-(\d+)/);
    return match?.[1] || '';
  };

  const partsFor = (row) => {
    const details = row?.querySelector('.cart-item__details');
    const error = row?.querySelector(ERROR);
    const text = error?.querySelector(ERROR_TEXT);
    return { details, error, text };
  };

  const showMessage = (row, message) => {
    const value = String(message || '').trim();
    if (!row || !value) return;

    const { details, error, text } = partsFor(row);
    if (!error || !text) return;
    if (details && error.parentElement !== details) details.appendChild(error);

    if (text.textContent !== value) text.textContent = value;
    error.dataset.gowinErrorActive = 'true';
    error.classList.add('gowin-cart-item-error-visible', 'is-visible');
    error.setAttribute('aria-hidden', 'false');
  };

  const clearMessage = (row) => {
    const { error, text } = partsFor(row);
    if (!error || !text) return;
    text.textContent = '';
    error.dataset.gowinErrorActive = 'false';
    error.classList.remove('is-visible');
    error.setAttribute('aria-hidden', 'true');
  };

  const availabilityQuantityFromMessage = (message) => {
    const value = String(message || '').replace(/\s+/g, ' ').trim();
    if (!value) return null;

    const patterns = [
      /\bsolo\s+se\s+(?:añadieron|agregaron)\s+(\d+)\s+(?:artículos|articulos|productos|unidades)\b/i,
      /\bsolo\s+(?:puedes|puede)\s+(?:añadir|agregar|comprar|tener)\s+(\d+)\b/i,
      /\bonly\s+(\d+)\s+(?:items?|products?|units?)\s+(?:were\s+)?added\b/i,
      /\b(?:you\s+can\s+)?only\s+(?:add|have|buy)\s+(\d+)\b/i,
      /\b(\d+)\s+(?:items?|products?|units?|artículos|articulos|productos|unidades)\s+(?:are\s+)?(?:available|disponibles?)\b/i,
    ];

    for (const pattern of patterns) {
      const match = value.match(pattern);
      const quantity = parseInt(match?.[1] || '', 10);
      if (Number.isInteger(quantity) && quantity > 0) return quantity;
    }

    return null;
  };

  const primeAvailabilityQuantity = (row, message) => {
    const quantity = availabilityQuantityFromMessage(message);
    if (!row || quantity === null) return;

    const input = row.querySelector(REAL_INPUT);
    if (!input) return;

    const expected = String(quantity);
    input.value = expected;

    const custom = row.querySelector('.gowin-cart-qty-inline__custom');
    if (custom) custom.value = expected;

    const select = row.querySelector('select.gowin-cart-qty-inline__select');
    if (!select) return;

    let option = [...select.options].find((item) => item.value === expected);
    if (!option) {
      option = document.createElement('option');
      option.value = expected;
      option.textContent = expected;
      option.dataset.gowinRecoveryOption = 'true';
      select.appendChild(option);
    }

    select.value = expected;
    select.dataset.gowinQtySignature = '';
  };

  const captureErrorText = (textNode) => {
    if (!(textNode instanceof Element) || !textNode.matches(ERROR_TEXT)) return;
    const message = String(textNode.textContent || '').trim();
    if (!message) return;

    const row = textNode.closest(ROW);
    const key = lineKey(row);
    if (!row || !/^\d+$/.test(key)) return;

    /*
      Shopify ya devolvió el límite real. Sincronizar input + selector dentro de
      la misma microtarea evita que el rAF de feed-style llegue a pintar el
      valor anterior antes del segundo request de confirmación.
    */
    primeAvailabilityQuantity(row, message);
    stickyMessages.set(key, message);
    showMessage(row, message);
  };

  const inspectMutation = (mutation) => {
    const target = mutation.target instanceof Element ? mutation.target : mutation.target?.parentElement;
    if (target?.matches?.(ERROR_TEXT)) captureErrorText(target);

    mutation.addedNodes?.forEach?.((node) => {
      if (!(node instanceof Element)) return;
      if (node.matches(ERROR_TEXT)) captureErrorText(node);
      node.querySelectorAll?.(ERROR_TEXT).forEach(captureErrorText);
    });
  };

  const reapplyStickyMessages = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (!drawer.querySelector(ROW)) {
      stickyMessages.clear();
      return;
    }

    stickyMessages.forEach((message, key) => {
      const input = drawer.querySelector(`${REAL_INPUT}[data-index="${key}"]`);
      const row = input?.closest(ROW) || drawer.querySelector(`#CartDrawer-Item-${key}`);
      if (row) showMessage(row, message);
    });
  };

  const clearForControl = (control) => {
    const row = control?.closest?.(ROW);
    const key = lineKey(row);
    if (key) stickyMessages.delete(key);
    if (row) clearMessage(row);
  };

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    observer?.disconnect();
    observer = new MutationObserver((mutations) => mutations.forEach(inspectMutation));
    observer.observe(drawer, { childList: true, subtree: true, characterData: true });
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.matches(QUANTITY_CONTROL)) return;
    clearForControl(target);
  }, true);

  document.addEventListener('click', (event) => {
    const remove = event.target?.closest?.('cart-remove-button, .cart-remove-button');
    if (remove) clearForControl(remove);
  }, true);

  document.addEventListener('gowin:cart-patched', () => {
    reapplyStickyMessages();
    requestAnimationFrame(reapplyStickyMessages);
  });

  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();
})();
;

/* gowin-cart-count-sync-v1.js */
/* GOWin® Store — sincronización robusta del contador del carrito */
(() => {
  'use strict';

  if (window.GowinCartCountSyncV1) return;
  window.GowinCartCountSyncV1 = true;

  let sectionRequest = null;
  let cartRequest = null;

  const cartIcon = () => document.getElementById('cart-icon-bubble');

  const normalizeCount = (value) => {
    const count = Number(value);
    return Number.isFinite(count) && count >= 0 ? Math.trunc(count) : null;
  };

  const syncVisibleCount = (value) => {
    const count = normalizeCount(value);
    const icon = cartIcon();
    if (count === null || !icon) return false;

    const bubble = icon.querySelector('.cart-count-bubble');

    if (count === 0) {
      bubble?.remove();
      icon.dataset.gowinCartCount = '0';
      return true;
    }

    if (!bubble) return false;

    const visible = bubble.querySelector('span[aria-hidden="true"]');
    if (visible) visible.textContent = count < 100 ? String(count) : '';

    const accessible = bubble.querySelector('span.visually-hidden');
    const accessibleText = String(accessible?.textContent || '');
    const previousMatch = accessibleText.match(/\d+/);
    const previousCount = normalizeCount(previousMatch?.[0]);

    if (accessible && previousMatch) {
      let nextText = accessibleText.replace(previousMatch[0], String(count));

      // Mantener correcta de inmediato la concordancia del storefront en español.
      if (/^es(?:-|$)/i.test(document.documentElement.lang || '')) {
        nextText = nextText.replace(/\bartículos?\b/gi, count === 1 ? 'artículo' : 'artículos');
      }

      accessible.textContent = nextText;
    }

    // Para idiomas con reglas plurales distintas, recuperar la etiqueta oficial
    // de Shopify únicamente cuando se cruza entre singular y plural.
    if (!accessible || !previousMatch || (previousCount === 1) !== (count === 1)) {
      refreshIconSection();
    }

    icon.dataset.gowinCartCount = String(count);
    return true;
  };

  const refreshIconSection = () => {
    const icon = cartIcon();
    if (!icon || !window.routes?.cart_url) return Promise.resolve(false);
    if (sectionRequest) return sectionRequest;

    const separator = routes.cart_url.includes('?') ? '&' : '?';
    const url = `${routes.cart_url}${separator}section_id=cart-icon-bubble`;

    sectionRequest = fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart-icon-bubble request failed');
        return response.text();
      })
      .then((html) => {
        const current = cartIcon();
        const markup = String(html || '').trim();
        if (!current || !markup) return false;
        current.innerHTML = markup;
        return true;
      })
      .catch(() => false)
      .finally(() => {
        sectionRequest = null;
      });

    return sectionRequest;
  };

  const syncFromState = (state) => {
    const count = normalizeCount(state?.item_count);
    if (count === null) return false;

    const hadMatchingBubble = syncVisibleCount(count);

    // Al quedar vacío hay que sustituir también el SVG por el estado vacío.
    // Si venimos de carrito vacío y se agrega algo, reconstruimos la burbuja completa.
    if (count === 0 || !hadMatchingBubble) refreshIconSection();
    return true;
  };

  const fetchCartState = () => {
    if (!window.routes?.cart_url) return Promise.resolve(null);
    if (cartRequest) return cartRequest;

    const base = String(routes.cart_url).replace(/\/$/, '');
    cartRequest = fetch(`${base}.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart.js request failed');
        return response.json();
      })
      .then((state) => {
        syncFromState(state);
        return state;
      })
      .catch(() => null)
      .finally(() => {
        cartRequest = null;
      });

    return cartRequest;
  };

  const stateFromDomEvent = (event) =>
    event?.detail?.cartData || event?.detail?.cart || event?.detail?.state || null;

  const installPubSub = () => {
    const subscribeFn = typeof subscribe === 'function' ? subscribe : window.subscribe;
    const events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;

    if (typeof subscribeFn !== 'function' || !events?.cartUpdate) return false;
    if (window.GowinCartCountPubSubInstalled) return true;

    window.GowinCartCountPubSubInstalled = true;
    subscribeFn(events.cartUpdate, (event) => {
      if (!syncFromState(event?.cartData || event?.cart || null)) fetchCartState();
    });
    return true;
  };

  const install = () => {
    installPubSub();
    fetchCartState();
  };

  document.addEventListener('cart:updated', (event) => {
    if (!syncFromState(stateFromDomEvent(event))) fetchCartState();
  });

  document.addEventListener('cart:refresh', (event) => {
    if (!syncFromState(stateFromDomEvent(event))) fetchCartState();
  });

  document.addEventListener('shopify:section:load', install);
  window.addEventListener('pageshow', fetchCartState);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', install, { once: true })
    : install();
})();
;

/* gowin-feed-menu-v2.js */
(() => {
  'use strict';

  const drawerSelector = '#menu-drawer';
  const blockId = 'gowin-menu-discovery';

  const secondaryPaths = new Set([
    '/collections/ofertas',
    '/collections/todos-los-productos',
    '/collections/packs-de-geles-y-carbohidratos-para-running-ciclismo-y-triatlon-en-costa-rica',
    '/blogs/noticias',
  ]);

  const brands = [
    {
      label: 'Carlyle',
      href: '/collections/carlyle-nutritionals',
      image: 'https://cdn.shopify.com/s/files/1/0970/7234/9549/collections/Carlyle-nutritional-suplementos-costa-rica.webp?v=1785564770',
    },
    {
      label: 'Maurten',
      href: '/collections/maurten',
      image: 'https://cdn.shopify.com/s/files/1/0970/7234/9549/collections/Maurten-Geles.webp?v=1785557122',
    },
    {
      label: 'SiS',
      href: '/collections/sis-science-in-sport',
      image: 'https://cdn.shopify.com/s/files/1/0970/7234/9549/collections/SIS-_Science_Sport.webp?v=1785561898',
    },
    {
      label: 'NatureWise',
      href: '/collections/natural-wise',
      image: 'https://cdn.shopify.com/s/files/1/0970/7234/9549/collections/NaturalWise.webp?v=1785565852',
    },
  ];

  const shortcuts = [
    { label: 'Ver ofertas', href: '/collections/ofertas', primary: true },
    { label: 'Todos los productos', href: '/collections/todos-los-productos' },
    {
      label: 'Packs deportivos',
      href: '/collections/packs-de-geles-y-carbohidratos-para-running-ciclismo-y-triatlon-en-costa-rica',
    },
    { label: 'Blog y consejos', href: '/blogs/noticias' },
  ];

  const pathOf = (value) => {
    try {
      const path = new URL(value, window.location.origin).pathname;
      return path.length > 1 ? path.replace(/\/+$/, '') : path;
    } catch {
      return '';
    }
  };

  const heading = (text, className) => {
    const node = document.createElement('h2');
    node.className = className;
    node.textContent = text;
    return node;
  };

  const brandLink = (brand) => {
    const link = document.createElement('a');
    link.className = 'gowin-menu-discovery__brand';
    link.href = brand.href;
    link.setAttribute('role', 'listitem');
    link.setAttribute('aria-label', `Ver productos ${brand.label}`);

    const image = document.createElement('img');
    image.className = 'gowin-menu-discovery__brand-image';
    image.src = brand.image;
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';

    const label = document.createElement('span');
    label.className = 'gowin-menu-discovery__brand-label';
    label.textContent = brand.label;

    link.append(image, label);
    return link;
  };

  const shortcutLink = (item) => {
    const link = document.createElement('a');
    link.className = 'gowin-menu-discovery__shortcut';
    if (item.primary) link.classList.add('gowin-menu-discovery__shortcut--primary');
    link.href = item.href;
    link.textContent = item.label;
    return link;
  };

  const createBlock = () => {
    const block = document.createElement('section');
    block.id = blockId;
    block.className = 'gowin-menu-discovery';
    block.setAttribute('aria-label', 'Descubrir GOWin Store');

    const rail = document.createElement('div');
    rail.className = 'gowin-menu-discovery__brands';
    rail.setAttribute('role', 'list');
    brands.forEach((brand) => rail.append(brandLink(brand)));

    const actions = document.createElement('div');
    actions.className = 'gowin-menu-discovery__shortcuts';
    shortcuts.forEach((item) => actions.append(shortcutLink(item)));

    block.append(
      heading('Marcas destacadas', 'gowin-menu-discovery__heading'),
      rail,
      heading('Explorar', 'gowin-menu-discovery__shortcut-heading'),
      actions
    );
    return block;
  };

  const enhanceDrawer = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    const navigation = drawer.querySelector('.menu-drawer__navigation');
    const container = drawer.querySelector('.menu-drawer__navigation-container');
    if (!navigation || !container) return;

    const list = Array.from(navigation.children).find(
      (node) => node.tagName === 'UL' && node.classList.contains('menu-drawer__menu')
    );
    if (!list) return;

    Array.from(list.children).forEach((item) => {
      const link = item.firstElementChild;
      if (link?.tagName !== 'A' || !secondaryPaths.has(pathOf(link.href))) return;
      item.hidden = true;
      item.classList.add('gowin-menu-secondary-item');
    });

    if (drawer.querySelector(`#${blockId}`)) return;
    const utility = drawer.querySelector('.menu-drawer__utility-links');
    const block = createBlock();
    utility?.parentElement === container
      ? container.insertBefore(block, utility)
      : container.append(block);
  };

  let scheduled = false;
  const run = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhanceDrawer();
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run, { once: true })
    : run();

  document.addEventListener('shopify:section:load', run);
  window.addEventListener('pageshow', run);
})();
;

/* gowin-menu-polish.js */
(() => {
  'use strict';

  const drawerSelector = '#menu-drawer';
  const detailsSelector = '#Details-menu-drawer-container';
  const closeClass = 'gowin-menu-close';
  const hiddenClass = 'gowin-menu-widget-hidden';
  const staticHeaderStyleId = 'gowin-menu-static-header-behavior';
  const closePatchFlag = '__gowinFastMainClosePatched';
  const root = document.documentElement;

  let observer = null;
  let sweepQueued = false;

  const detailsElement = () => document.querySelector(detailsSelector);
  const summaryElement = () => document.querySelector(`${detailsSelector} > summary`);

  const patchMainCloseAnimation = (HeaderDrawer) => {
    if (!HeaderDrawer || HeaderDrawer.prototype[closePatchFlag]) return;

    const originalCloseAnimation = HeaderDrawer.prototype.closeAnimation;
    if (typeof originalCloseAnimation !== 'function') return;

    HeaderDrawer.prototype.closeAnimation = function (details) {
      if (!(details instanceof HTMLElement) || !details.matches(detailsSelector)) {
        return originalCloseAnimation.call(this, details);
      }

      const drawer = details.querySelector(drawerSelector);
      let finished = false;
      let fallbackTimer = 0;
      let onTransitionEnd = null;

      const finish = () => {
        if (finished) return;
        finished = true;
        if (drawer && onTransitionEnd) drawer.removeEventListener('transitionend', onTransitionEnd);
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        details.removeAttribute('open');
      };

      onTransitionEnd = (event) => {
        if (event.target !== drawer || event.propertyName !== 'transform') return;
        finish();
      };

      if (drawer) drawer.addEventListener('transitionend', onTransitionEnd);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !drawer) {
        window.requestAnimationFrame(finish);
        return;
      }

      fallbackTimer = window.setTimeout(finish, 280);
    };

    Object.defineProperty(HeaderDrawer.prototype, closePatchFlag, {
      value: true,
      configurable: false,
      enumerable: false,
      writable: false,
    });
  };

  const ensureMainClosePatch = () => {
    const HeaderDrawer = customElements.get('header-drawer');
    if (HeaderDrawer) {
      patchMainCloseAnimation(HeaderDrawer);
      return;
    }

    customElements.whenDefined('header-drawer').then(() => {
      patchMainCloseAnimation(customElements.get('header-drawer'));
    });
  };

  const ensureStaticHeaderStyles = () => {
    if (document.getElementById(staticHeaderStyleId)) return;

    const style = document.createElement('style');
    style.id = staticHeaderStyleId;
    style.textContent = `
      @media screen and (max-width: 989px) {
        #menu-drawer.menu-drawer {
          transition:
            transform 220ms cubic-bezier(.22, 1, .36, 1),
            visibility 0s linear !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) header-drawer,
        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .menu-drawer-container {
          position: relative !important;
          z-index: 40 !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) #menu-drawer.menu-drawer {
          z-index: 41 !important;
          isolation: isolate !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header > .header__icons,
        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .gowin-mobile-search,
        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) #cart-icon-bubble {
          position: relative !important;
          z-index: 0 !important;
          pointer-events: none !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header-wrapper {
          width: 100% !important;
          height: auto !important;
          min-height: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          border-bottom: 1px solid rgba(16, 26, 43, .08) !important;
          background: rgba(255, 255, 255, .94) !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header {
          width: 100% !important;
          height: 5.4rem !important;
          min-height: 5.4rem !important;
          margin: 0 !important;
          padding: .5rem 1rem !important;
          border: 0 !important;
          background: transparent !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header > .header__heading {
          display: block !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header > .header__heading-link {
          display: inline-flex !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header > .header__icons {
          display: flex !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) header-drawer {
          position: static !important;
          display: block !important;
          width: auto !important;
          height: auto !important;
          margin: 0 !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .menu-drawer-container {
          position: static !important;
          display: flex !important;
          width: auto !important;
          height: auto !important;
          margin: 0 !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .gowin-mobile-search {
          visibility: visible !important;
          opacity: 1 !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu {
          position: static !important;
          z-index: auto !important;
          display: grid !important;
          place-items: center !important;
          width: 4.4rem !important;
          min-width: 4.4rem !important;
          height: 4.4rem !important;
          min-height: 4.4rem !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
          opacity: 1 !important;
          pointer-events: auto !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu > span {
          display: inline-flex !important;
          width: auto !important;
          height: auto !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu svg {
          display: block !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu .icon-hamburger {
          visibility: visible !important;
          opacity: 1 !important;
          transform: none !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu .icon-close {
          visibility: hidden !important;
          opacity: 0 !important;
          transform: none !important;
        }

        html.gowin-menu-open .section-header,
        html.gowin-menu-open .section-header .header-wrapper,
        html.gowin-menu-open .section-header .header,
        html.gowin-menu-open .section-header .header__heading,
        html.gowin-menu-open .section-header .header__heading-link,
        html.gowin-menu-open .section-header .header__heading-logo-wrapper,
        html.gowin-menu-open .section-header .header__heading-logo,
        html.gowin-menu-open .section-header .header__icons,
        html.gowin-menu-open .section-header .header__icon,
        html.gowin-menu-closing .section-header,
        html.gowin-header-returning .section-header,
        html.gowin-header-returning .section-header .header__heading-logo,
        html.gowin-header-returning .section-header .header__icon {
          animation: none !important;
          transition: none !important;
        }

        html.gowin-menu-closing .section-header,
        html.gowin-header-returning .section-header {
          opacity: 1 !important;
          visibility: visible !important;
          transform: none !important;
          pointer-events: auto !important;
        }
      }
    `;

    (document.head || document.documentElement).appendChild(style);
  };

  const resetMenuPosition = () => {
    const details = detailsElement();
    const drawer = document.querySelector(drawerSelector);
    if (!details || !drawer) return;

    details.querySelectorAll('details').forEach((nestedDetails) => {
      nestedDetails.removeAttribute('open');
      nestedDetails.classList.remove('menu-opening', 'submenu-open');

      const nestedSummary = nestedDetails.querySelector(':scope > summary');
      nestedSummary?.setAttribute('aria-expanded', 'false');
    });

    drawer.querySelectorAll('.submenu-open, .menu-opening').forEach((element) => {
      element.classList.remove('submenu-open', 'menu-opening');
    });

    const scrollableElements = [
      drawer,
      ...drawer.querySelectorAll(
        '.menu-drawer__navigation-container,' +
          '.menu-drawer__navigation,' +
          '.menu-drawer__inner-container,' +
          '.menu-drawer__submenu,' +
          '.menu-drawer__inner-submenu'
      ),
    ];

    scrollableElements.forEach((element) => {
      element.scrollTop = 0;
      element.scrollLeft = 0;
    });
  };

  const closeMenu = () => {
    const summary = summaryElement();
    if (summary instanceof HTMLElement) summary.click();
  };

  const ensureCloseButton = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer || drawer.querySelector(`.${closeClass}`)) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = closeClass;
    button.setAttribute('aria-label', 'Cerrar menú');

    const glyph = document.createElement('span');
    glyph.setAttribute('aria-hidden', 'true');
    button.append(glyph);
    button.addEventListener('click', closeMenu);
    drawer.append(button);
  };

  const likelyFloatingWidget = (element) => {
    if (!(element instanceof HTMLElement) || element.closest(drawerSelector)) return false;
    const style = getComputedStyle(element);
    if (style.position !== 'fixed') return false;
    const rect = element.getBoundingClientRect();
    return (
      window.innerWidth - rect.right <= 56 &&
      window.innerHeight - rect.bottom <= 250 &&
      rect.width >= 38 &&
      rect.width <= 150 &&
      rect.height >= 38 &&
      rect.height <= 150
    );
  };

  const candidates = () => {
    const explicit = document.querySelectorAll(
      "[id*='whatsapp' i],[class*='whatsapp' i],a[href*='wa.me' i],a[href*='api.whatsapp.com' i],a[href*='whatsapp.com' i],iframe[src*='whatsapp' i],#shopify-chat,[data-shopify-chat]"
    );
    const compactFixed = Array.from(document.body.querySelectorAll('*')).filter(likelyFloatingWidget);
    return [...new Set([...explicit, ...compactFixed])];
  };

  const hideWidgets = () => {
    candidates().forEach((node) => {
      const wrapper =
        node.closest("[id*='whatsapp' i],[class*='whatsapp' i],[data-shopify-chat]") || node;
      if (!wrapper.closest(drawerSelector)) wrapper.classList.add(hiddenClass);
    });
  };

  const restoreWidgets = () => {
    document.querySelectorAll(`.${hiddenClass}`).forEach((node) => {
      node.classList.remove(hiddenClass);
    });
  };

  const queueSweep = () => {
    if (sweepQueued) return;
    sweepQueued = true;
    requestAnimationFrame(() => {
      sweepQueued = false;
      if (root.classList.contains('gowin-menu-open')) hideWidgets();
    });
  };

  const startObserver = () => {
    if (observer || !document.body) return;
    observer = new MutationObserver(queueSweep);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const stopObserver = () => {
    observer?.disconnect();
    observer = null;
  };

  const beginOpen = () => {
    root.classList.remove('gowin-menu-closing', 'gowin-header-returning');
    resetMenuPosition();
    root.classList.add('gowin-menu-open');
    hideWidgets();
    startObserver();
    queueSweep();
    requestAnimationFrame(resetMenuPosition);
  };

  const finishClose = () => {
    stopObserver();
    root.classList.remove('gowin-menu-open', 'gowin-menu-closing', 'gowin-header-returning');
    resetMenuPosition();
    restoreWidgets();
  };

  const bindState = () => {
    const details = detailsElement();
    const summary = summaryElement();
    if (!details || !summary || details.dataset.gowinPolishBound === 'true') return;
    details.dataset.gowinPolishBound = 'true';

    summary.addEventListener(
      'click',
      () => {
        if (!details.hasAttribute('open')) resetMenuPosition();
      },
      true
    );

    const sync = () => {
      details.hasAttribute('open') ? beginOpen() : finishClose();
    };

    details.addEventListener('toggle', sync);
    sync();
  };

  const run = () => {
    ensureStaticHeaderStyles();
    ensureMainClosePatch();
    root.classList.remove('gowin-menu-closing', 'gowin-header-returning');
    ensureCloseButton();
    bindState();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run, { once: true })
    : run();

  document.addEventListener('shopify:section:load', run);
  window.addEventListener('pageshow', run);
})();
;

/* gowin-store-credit-ui-v1.js */
(() => {
  'use strict';

  const SELECTORS = {
    account: '.section-header .header__icon--account',
    header: '.section-header',
    headerRow: '.section-header .header.page-width',
    icons: '.section-header .header__icons',
    bridge: '#GowinStoreCreditBridge',
    announcement: '[data-gowin-announcement]',
    announcementLabelViewport: '.gowin-announcement__label-viewport'
  };

  const mobileMedia = window.matchMedia('(max-width: 989px)');
  const announcementMobileMedia = window.matchMedia('(max-width: 749px)');
  const announcementDesktopMedia = window.matchMedia('(min-width: 990px)');
  const reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
  let originalAccountParent = null;
  let originalAccountNextSibling = null;
  let syncTimer = 0;
  let rewardAnimationTimer = 0;
  let rewardEntranceRequestTimer = 0;

  const readCreditState = () => {
    const bridge = document.querySelector(SELECTORS.bridge);

    return {
      authenticated: bridge?.dataset.authenticated === 'true',
      balance: String(bridge?.dataset.balance || '').trim() || '₡0'
    };
  };

  const rememberDesktopPosition = (account) => {
    if (originalAccountParent || !account?.parentElement) return;
    originalAccountParent = account.parentElement;
    originalAccountNextSibling = account.nextSibling;
  };

  const restoreAccountHome = (account) => {
    if (!account || !originalAccountParent?.isConnected) return;
    if (account.parentElement === originalAccountParent) return;

    const next = originalAccountNextSibling;
    if (next?.isConnected && next.parentElement === originalAccountParent) {
      originalAccountParent.insertBefore(account, next);
      return;
    }

    originalAccountParent.appendChild(account);
  };

  const placeAccount = (account) => {
    if (!account) return;

    const icons = document.querySelector(SELECTORS.icons);
    if (!icons) return;

    rememberDesktopPosition(account);

    if (mobileMedia.matches) {
      restoreAccountHome(account);
      return;
    }

    const targetParent = originalAccountParent?.isConnected ? originalAccountParent : icons;
    if (account.parentElement === targetParent) return;

    const next = originalAccountNextSibling;
    if (next?.isConnected && next.parentElement === targetParent) {
      targetParent.insertBefore(account, next);
      return;
    }

    const fallback = targetParent.querySelector('.gowin-search-toggle, .header__icon--cart');
    targetParent.insertBefore(account, fallback || null);
  };

  const syncAccount = () => {
    const account = document.querySelector(SELECTORS.account);
    if (!account) return;

    rememberDesktopPosition(account);
    placeAccount(account);

    const state = readCreditState();
    if (!state.authenticated) return;

    if (announcementDesktopMedia.matches) {
      account.querySelector('.gowin-account-credit__copy')?.remove();
      account.classList.remove('gowin-account-credit');
      account.setAttribute(
        'aria-label',
        `Tu cuenta. Recompensas disponibles ${state.balance}. Abrir cuenta`
      );
      account.title = `Recompensas disponibles: ${state.balance}`;
      return;
    }

    if (mobileMedia.matches) {
      account.setAttribute('aria-label', 'Tu cuenta. Abrir cuenta');
      account.removeAttribute('title');
      return;
    }

    const existingAmount = account.querySelector('.gowin-account-credit__amount');

    if (existingAmount) {
      if (existingAmount.textContent !== state.balance) {
        existingAmount.textContent = state.balance;
      }

      account.setAttribute(
        'aria-label',
        `Tu cuenta. Recompensas disponibles ${state.balance}. Abrir cuenta`
      );
      account.title = `Recompensas disponibles: ${state.balance}`;
      placeAccount(account);
      return;
    }

    const icon = account.querySelector('account-icon, .svg-wrapper');
    const iconClone = icon?.cloneNode(true) || null;

    const copy = document.createElement('span');
    copy.className = 'gowin-account-credit__copy';

    const label = document.createElement('span');
    label.className = 'gowin-account-credit__label';
    label.textContent = 'RECOMPENSAS';

    const balanceRow = document.createElement('span');
    balanceRow.className = 'gowin-account-credit__balance';

    const balanceLabel = document.createElement('span');
    balanceLabel.textContent = 'Saldo';

    const amount = document.createElement('strong');
    amount.className = 'gowin-account-credit__amount';
    amount.textContent = state.balance;

    balanceRow.append(balanceLabel, amount);
    copy.append(label, balanceRow);

    account.replaceChildren();

    if (iconClone) {
      account.appendChild(iconClone);
    }

    account.appendChild(copy);
    account.classList.add('gowin-account-credit');
    account.setAttribute(
      'aria-label',
      `Tu cuenta. Recompensas disponibles ${state.balance}. Abrir cuenta`
    );
    account.title = `Recompensas disponibles: ${state.balance}`;
    placeAccount(account);
  };

  const ensureRewardStyles = () => {
    if (document.getElementById('GowinMobileRewardAnnouncementStyles')) return;

    const style = document.createElement('style');
    style.id = 'GowinMobileRewardAnnouncementStyles';
    style.textContent = `
      @media screen and (max-width: 749px) {
        .section-header .header__icon--cart .svg-wrapper svg {
          transform: scale(1.14) !important;
          transform-origin: 50% 50% !important;
        }

        [data-gowin-announcement][data-gowin-rewards-locked="true"] .gowin-announcement__label-viewport {
          position: relative !important;
          overflow: hidden !important;
        }

        [data-gowin-announcement][data-gowin-rewards-locked="true"] [data-gowin-label] {
          visibility: hidden !important;
          pointer-events: none !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock {
          box-sizing: border-box !important;
          position: absolute !important;
          inset: 0 !important;
          z-index: 3 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          height: 100% !important;
          padding: 0 .38rem !important;
          color: inherit !important;
          white-space: nowrap !important;
          pointer-events: none !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-stack {
          display: grid !important;
          grid-template-columns: 1.92rem auto !important;
          grid-template-rows: auto auto !important;
          align-items: center !important;
          justify-content: center !important;
          column-gap: .38rem !important;
          row-gap: .05rem !important;
          width: max-content !important;
          max-width: 100% !important;
          line-height: 1 !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-main {
          display: contents !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-dot {
          grid-column: 1 !important;
          grid-row: 1 / span 2 !important;
          align-self: center !important;
          flex: 0 0 auto !important;
          width: 1.92rem !important;
          height: 1.92rem !important;
          border-radius: 0 !important;
          background-color: transparent !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M5 6.25h11.4a2.6 2.6 0 0 1 2.6 2.6v8.15A2.5 2.5 0 0 1 16.5 19.5h-11A2.5 2.5 0 0 1 3 17V7.75A2.5 2.5 0 0 1 5.5 5.25H16' stroke='%230d2b4d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M15.25 11.25H21v4.5h-5.75a2.25 2.25 0 0 1 0-4.5Z' stroke='%230d2b4d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='16.15' cy='13.5' r='.9' fill='%230d2b4d'/%3E%3C/svg%3E") !important;
          background-position: center !important;
          background-repeat: no-repeat !important;
          background-size: contain !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-amount {
          grid-column: 2 !important;
          grid-row: 1 !important;
          justify-self: start !important;
          flex: 0 0 auto !important;
          font-size: 1.34rem !important;
          font-weight: 850 !important;
          letter-spacing: -.03em !important;
          line-height: .95 !important;
          font-variant-numeric: tabular-nums !important;
          will-change: transform, opacity, clip-path !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-label {
          grid-column: 2 !important;
          grid-row: 2 !important;
          justify-self: start !important;
          display: block !important;
          width: auto !important;
          min-width: 0 !important;
          text-align: left !important;
          font-size: .66rem !important;
          font-weight: 700 !important;
          letter-spacing: .075em !important;
          line-height: 1 !important;
          text-transform: uppercase !important;
          will-change: transform, opacity, clip-path !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock.gowin-reward-entering .gowin-announcement__reward-lock-amount,
        [data-gowin-announcement] .gowin-announcement__reward-lock.gowin-reward-entering .gowin-announcement__reward-lock-label {
          animation: gowinRewardTextReveal 560ms cubic-bezier(.22,1,.36,1) both !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock.gowin-reward-entering .gowin-announcement__reward-lock-label {
          animation-delay: 70ms !important;
        }

        @keyframes gowinRewardTextReveal {
          0% {
            opacity: 0;
            transform: translateX(-.55rem);
            clip-path: inset(0 100% 0 0);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
            clip-path: inset(0 0 0 0);
          }
        }
      }


      @media screen and (min-width: 990px) {
        [data-gowin-announcement][data-gowin-rewards-locked="true"] .gowin-announcement__label-viewport {
          position: relative !important;
          overflow: hidden !important;
          background: linear-gradient(102deg, #d7ff7a 0%, #b7ed43 54%, #8bc53f 100%) !important;
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, .34),
            inset 0 -1px 0 rgba(13, 73, 70, .18),
            inset -1px 0 0 rgba(18, 59, 100, .12) !important;
        }

        [data-gowin-announcement][data-gowin-rewards-locked="true"] .gowin-announcement-desktop__fixed {
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock {
          box-sizing: border-box !important;
          position: absolute !important;
          inset: 0 !important;
          z-index: 4 !important;
          isolation: isolate !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          height: 100% !important;
          padding: 0 1rem !important;
          overflow: hidden !important;
          color: #123b64 !important;
          white-space: nowrap !important;
          pointer-events: none !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock::before {
          content: none !important;
          display: none !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-stack {
          box-sizing: border-box !important;
          position: relative !important;
          z-index: 1 !important;
          display: grid !important;
          grid-template-columns: 2.2rem auto auto !important;
          grid-template-rows: minmax(0, 1fr) !important;
          align-items: center !important;
          justify-content: center !important;
          column-gap: .5rem !important;
          width: max-content !important;
          max-width: 100% !important;
          min-width: 0 !important;
          margin: 0 auto !important;
          line-height: 1 !important;
          transition: transform 220ms cubic-bezier(.22, 1, .36, 1) !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-main {
          display: contents !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-dot {
          grid-column: 1 !important;
          grid-row: 1 !important;
          align-self: center !important;
          width: 2.2rem !important;
          height: 2.2rem !important;
          border: 1px solid rgba(255, 255, 255, .48) !important;
          border-radius: 999px !important;
          background-color: #123b64 !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M13.15 6.8 8.9 12h2.75l-.95 5.2 4.45-5.7h-2.8l.8-4.7Z' fill='%23b7ed43'/%3E%3C/svg%3E") !important;
          background-position: center !important;
          background-repeat: no-repeat !important;
          background-size: 1.55rem 1.55rem !important;
          box-shadow: 0 .12rem .32rem rgba(18, 59, 100, .16), inset 0 1px 0 rgba(255, 255, 255, .18) !important;
          filter: none !important;
          transform-origin: 50% 50% !important;
          transition: transform 220ms cubic-bezier(.22, 1, .36, 1) !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-label {
          grid-column: 2 !important;
          grid-row: 1 !important;
          justify-self: start !important;
          align-self: center !important;
          display: block !important;
          width: auto !important;
          min-width: 0 !important;
          padding: 0 !important;
          border: 0 !important;
          color: #123b64 !important;
          text-align: left !important;
          font-size: .92rem !important;
          font-weight: 760 !important;
          letter-spacing: .016em !important;
          line-height: 1 !important;
          text-transform: uppercase !important;
          will-change: transform, opacity, clip-path !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock-amount {
          grid-column: 3 !important;
          grid-row: 1 !important;
          justify-self: start !important;
          align-self: center !important;
          display: inline-flex !important;
          align-items: center !important;
          min-width: max-content !important;
          min-height: 0 !important;
          padding: 0 !important;
          border: 0 !important;
          border-radius: 0 !important;
          background: transparent !important;
          box-shadow: none !important;
          color: #0d4946 !important;
          font-size: 1.28rem !important;
          font-weight: 760 !important;
          letter-spacing: -.028em !important;
          line-height: 1 !important;
          font-variant-numeric: tabular-nums !important;
          transition: color 220ms ease, transform 220ms cubic-bezier(.22, 1, .36, 1) !important;
          will-change: transform, opacity, clip-path !important;
        }

        [data-gowin-announcement]:hover .gowin-announcement__reward-lock-stack {
          transform: translateY(-1px) !important;
        }

        [data-gowin-announcement]:hover .gowin-announcement__reward-lock-dot {
          transform: scale(1.025) !important;
        }

        [data-gowin-announcement]:hover .gowin-announcement__reward-lock-amount {
          transform: none !important;
          color: #083d3a !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock.gowin-reward-entering .gowin-announcement__reward-lock-amount,
        [data-gowin-announcement] .gowin-announcement__reward-lock.gowin-reward-entering .gowin-announcement__reward-lock-label {
          animation: gowinRewardTextRevealDesktop 360ms cubic-bezier(.22,1,.36,1) both !important;
        }

        [data-gowin-announcement] .gowin-announcement__reward-lock.gowin-reward-entering .gowin-announcement__reward-lock-amount {
          animation-delay: 40ms !important;
        }

        @keyframes gowinRewardTextRevealDesktop {
          0% {
            opacity: 0;
            transform: translateX(-.3rem);
            clip-path: inset(0 100% 0 0);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
            clip-path: inset(0 0 0 0);
          }
        }
      }

      @media (prefers-reduced-motion: reduce) {
        [data-gowin-announcement] .gowin-announcement__reward-lock-amount,
        [data-gowin-announcement] .gowin-announcement__reward-lock-label {
          animation: none !important;
          transform: none !important;
          clip-path: none !important;
          opacity: 1 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const playRewardEntrance = (lock) => {
    if (!lock || reducedMotionMedia.matches) return;

    window.clearTimeout(rewardAnimationTimer);
    if (lock.classList.contains('gowin-reward-entering')) return;
    lock.classList.add('gowin-reward-entering');

    rewardAnimationTimer = window.setTimeout(() => {
      lock.classList.remove('gowin-reward-entering');
    }, 760);
  };

  const removeRewardLock = (root) => {
    if (!root) return;
    root.removeAttribute('data-gowin-rewards-locked');
    root.querySelector('.gowin-announcement__reward-lock')?.remove();
  };

  const syncMobileRewardAnnouncement = () => {
    ensureRewardStyles();

    const root = document.querySelector(SELECTORS.announcement);
    if (!root) return;

    const state = readCreditState();
    const rewardsBelongInAnnouncement =
      announcementMobileMedia.matches || announcementDesktopMedia.matches;

    if (!rewardsBelongInAnnouncement || !state.authenticated) {
      removeRewardLock(root);
      return;
    }

    const viewport = root.querySelector(SELECTORS.announcementLabelViewport);
    if (!viewport) return;

    root.dataset.gowinRewardsLocked = 'true';

    let lock = viewport.querySelector('.gowin-announcement__reward-lock');
    if (!lock) {
      lock = document.createElement('div');
      lock.className = 'gowin-announcement__reward-lock';
      viewport.appendChild(lock);
    }

    if (!lock.querySelector('.gowin-announcement__reward-lock-main')) {
      lock.innerHTML = `
        <span class="gowin-announcement__reward-lock-stack">
          <span class="gowin-announcement__reward-lock-main">
            <span class="gowin-announcement__reward-lock-dot" aria-hidden="true"></span>
            <strong class="gowin-announcement__reward-lock-amount"></strong>
          </span>
          <span class="gowin-announcement__reward-lock-label">RECOMPENSAS</span>
        </span>
      `;
    }

    const amount = lock.querySelector('.gowin-announcement__reward-lock-amount');
    if (amount && amount.textContent !== state.balance) {
      amount.textContent = state.balance;
    }

    lock.setAttribute('aria-label', `Recompensas disponibles ${state.balance}`);
  };

  const syncAll = () => {
    syncAccount();
    syncMobileRewardAnnouncement();
  };

  const scheduleSync = () => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncAll, 40);
  };

  const scheduleRewardEntrance = () => {
    window.clearTimeout(rewardEntranceRequestTimer);

    rewardEntranceRequestTimer = window.setTimeout(() => {
      if (
        reducedMotionMedia.matches ||
        (!announcementMobileMedia.matches && !announcementDesktopMedia.matches)
      ) return;

      syncMobileRewardAnnouncement();
      const lock = document.querySelector('.gowin-announcement__reward-lock');
      playRewardEntrance(lock);
    }, 120);
  };

  const observeHeader = () => {
    const header = document.querySelector(SELECTORS.header);

    if (!header || header.dataset.gowinCreditObserved === 'true') return;

    header.dataset.gowinCreditObserved = 'true';
    new MutationObserver(scheduleSync).observe(header, {
      childList: true,
      subtree: true
    });
  };

  const observeAnnouncementLifecycle = () => {
    if (document.documentElement.dataset.gowinRewardAnnouncementObserved === 'true') return;
    document.documentElement.dataset.gowinRewardAnnouncementObserved = 'true';

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (!mutation.addedNodes.length && !mutation.removedNodes.length) continue;

        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (
            node.matches?.(SELECTORS.announcement) ||
            node.querySelector?.(SELECTORS.announcement) ||
            node.matches?.(SELECTORS.bridge) ||
            node.querySelector?.(SELECTORS.bridge)
          ) {
            scheduleSync();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  const boot = () => {
    syncAll();
    observeHeader();
    observeAnnouncementLifecycle();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot, { once: true })
    : boot();

  document.addEventListener('shopify:section:load', boot);

  window.addEventListener('pageshow', (event) => {
    scheduleSync();

    /* En BFCache Safari restaura un snapshot vivo: no reanimar ni forzar layout. */
    if (event.persisted) return;
    scheduleRewardEntrance();
  });

  const bindMedia = (media) => {
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', scheduleSync);
    } else {
      media.addListener(scheduleSync);
    }
  };

  bindMedia(mobileMedia);
  bindMedia(announcementMobileMedia);
  bindMedia(announcementDesktopMedia);
})();
;
